import React from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import Navbar from './components/Navbar';
import About from './pages/About/About';
import Aims from './pages/Aims/Aims';
import Collaborators from './pages/Collaborators/Collaborators';
import Project from './pages/Project/Project';
import Home from './pages/Landing/Home';
import Footer from './components/Footer';
import Events from './pages/Events/Events'
import EventsDetailPage from './pages/Events/EventsDetailPage';
import CookiesPolicy from './components/CookiesPolicy';

const App = () => {
    return (
        <Router>
            <Navbar />
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/about" element={<About />} />
                <Route path="/aims" element={<Aims />} />
                <Route path="/collaborators" element={<Collaborators />} />
                <Route path="/project" element={<Project />} />
                <Route path="*" element={<Navigate to="/" replace />} />
                <Route path="/events" element={<Events />} />
                <Route path="/events/:slug" element={<EventsDetailPage />} />
            </Routes>
            <CookiesPolicy />
            <Footer />
        </Router>
    );
};

export default App;
